class SlotSpinner extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.bk-cta__slot-track')
    if (!track) return

    const items = Array.from(track.querySelectorAll('.bk-cta__slot-name'))
    const count = items.length
    if (count <= 1) return

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const idx = Math.floor(Math.random() * count)
      const h = items[0].getBoundingClientRect().height
      track.style.transform = `translateY(${-h * idx}px)`
      return
    }

    requestAnimationFrame(() => this.spin(track, items, count))
  }

  spin(track, originals, count) {
    const itemHeight = originals[0].getBoundingClientRect().height
    if (!itemHeight) return

    const cycles = 5
    const frag = document.createDocumentFragment()
    for (let c = 0; c < cycles; c++) {
      for (let i = 0; i < count; i++) {
        frag.appendChild(originals[i].cloneNode(true))
      }
    }
    track.appendChild(frag)

    let currentIdx = 0

    const spinOnce = () => {
      const targetIdx = Math.floor(Math.random() * count)
      const startY = -itemHeight * currentIdx
      const finalY = -itemHeight * (cycles * count + targetIdx)
      const midY = startY + (finalY - startY) * 0.55
      const duration = 700 + Math.random() * 700

      track.style.willChange = 'transform, filter'

      const anim = track.animate(
        [
          { transform: `translateY(${startY}px)`, filter: 'blur(0)', offset: 0 },
          { transform: `translateY(${midY}px)`, filter: 'blur(1.5px)', offset: 0.55 },
          { transform: `translateY(${finalY}px)`, filter: 'blur(0)', offset: 1 },
        ],
        {
          duration,
          easing: 'cubic-bezier(0.16, 0.7, 0.18, 1)',
          fill: 'forwards',
        }
      )

      anim.addEventListener('finish', () => {
        track.style.willChange = ''
        // Collapse to equivalent position so next spin starts within bounds.
        track.style.transform = `translateY(${-itemHeight * targetIdx}px)`
        currentIdx = targetIdx
        anim.cancel()
        this._timer = setTimeout(spinOnce, 700)
      })
    }

    spinOnce()
  }

  disconnectedCallback() {
    if (this._timer) clearTimeout(this._timer)
  }
}

if (!customElements.get('slot-spinner')) {
  customElements.define('slot-spinner', SlotSpinner)
}
